function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { Redirect, useLocation } from 'react-router-dom';
import { defaultAuthorizedRoute } from "../../constants";
import { useStore } from "../../contexts";
import { selectors } from "../../store/state-selectors";

/**
 * Prevents access to the page if the user is a partially onboarded vendor (does not have a business).
 */
import { jsx as _jsx } from "react/jsx-runtime";
export function withBlockPartiallyOnboardedVendor(Component) {
  return function WithBlockPartiallyOnboardedVendor(props) {
    const location = useLocation();
    const businessId = useStore(selectors.user.businessId);
    const userId = useStore(selectors.user.id);
    const isPartiallyOnboardedVendor = !!userId && !businessId;
    const defaultRouteForVendor = defaultAuthorizedRoute(true);
    return isPartiallyOnboardedVendor ? location.pathname === defaultRouteForVendor ? /*#__PURE__*/_jsx("div", {
      "data-testid": "blocked-partially-onboarded-vendor"
    }) : /*#__PURE__*/_jsx(Redirect, {
      to: {
        pathname: defaultRouteForVendor,
        search: location.search
      }
    }) : /*#__PURE__*/_jsx(Component, _objectSpread({}, props));
  };
}